<template src="./ownership.html"></template>
<script>  
  import Multiselect from "vue-multiselect";
  import Axios from "axios";
  import $ from "jquery";  

  export default {
    components: {      
      Multiselect,
    },
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },      
    },
    data() {
      return {
        basic: {
          currentPage: 1,
          totalPages: 0,
        },        
        ShowLoader: false,
        SearchForm: {
          Name: "",
        },
        OwnershipList: [],
        ShowOwnershipAddModel: "",
        SubmitOwnership: {},
        ShowOwnershipAdd: false,
        ShowOwnershipEdit: false,
        ShowOwnershipDelete: false,
      };
    },
    mounted() {
      /*var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Assets.Ownership || !AccountPermissions.Assets.Ownership.enable)
      ) {
        this.$router.push("/");
      }

      if (
        AccountPermissions &&
        AccountPermissions.Assets.Ownership &&
        AccountPermissions.Assets.Ownership.enable
      ) {
        if (AccountPermissions.Assets.Ownership.add) {
          this.ShowOwnershipAdd = true;
        }
        if (AccountPermissions.Assets.Ownership.edit) {
          this.ShowOwnershipEdit = true;
        }
        if (AccountPermissions.Assets.Ownership.delete) {
          this.ShowOwnershipDelete = true;
        }
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowOwnershipAdd = true;
        this.ShowOwnershipEdit = true;
        this.ShowOwnershipDelete = true;
      }*/

      this.ShowOwnershipAdd = true;
      this.ShowOwnershipEdit = true;
      this.ShowOwnershipDelete = true;
      
      document.title = pbx_SiteTitle + " - Assets Ownership";
      this.GetOwnershipList();
    },

    methods: {
      initSubmitOwnershipObject() {
        this.SubmitOwnership = {
          	id: 0,
          	name: "",
        };
      },
      GetOwnershipList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.name = this.SearchForm.Name;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Ownership.List, obj).then((Response) => {
          	this.ShowLoader = false;
          	if (Response?.data?.success) {
            	this.OwnershipList = Response.data.OwnershipList;
          	}
        });
      },
      AddNewOwnership() {
        this.ShowOwnershipAddModel = true;
    	this.initSubmitOwnershipObject();
      },
      EditOwnership(Ownership) {
        this.ShowOwnershipAddModel = true;
        this.SubmitOwnership = {};
        this.SubmitOwnership.id = Ownership.id;
        this.SubmitOwnership.name = Ownership.name;
      },
      AddOwnershipSubmit() {
        var error = false;
        var errorStr = "";
        if (!this.SubmitOwnership.name) {
          error = true;
          errorStr += "<li>Please Enter Ownership Name</li>";
        }
        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(() => {});
        } else {
          this.$swal({
            title: "Adding Ownership...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          var postUrl = Endpoints.Assets.Ownership.Create;
          if (this.SubmitOwnership && this.SubmitOwnership.id > 0) {
            postUrl = Endpoints.Assets.Ownership.Update;
          }
          Axios.post(postUrl, {
            token: localStorage.getItem("token"),
            SubmitOwnership: this.SubmitOwnership,
          }).then((Response) => {
            if (Response?.data?.success == true) {
              	this.ShowOwnershipAddModel = false;
              	this.GetOwnershipList();
              	this.initSubmitOwnershipObject();
              	this.$swal("Ownership Added Successfully", "", "success").then(() => {});
            } else {
              	this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          });
        }
      },
      DeleteOwnership(Ownership) {
        this.$swal
          .fire({
            title: "Are you sure You want to Delete this Ownership?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete it!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal({
                title: "Deleting Ownership...",
                text: "Please wait...",
                imageUrl: require("@/assets/images/LoadingTwo.gif"),
                showConfirmButton: false,
                allowOutsideClick: false,
              });

              Axios.post(Endpoints.Assets.Ownership.Delete, {
                token: localStorage.getItem("token"),
                id: Ownership.id,
              }).then((Response) => {
                if (Response?.data?.success == true) {
                  this.GetOwnershipList();
                  this.$swal("Ownership Deleted Successfully","","success").then(() => {});
                } else {
                  this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
                }
              });
            }
          });
      },
    },
  };
</script>
